module.exports = __webpack_public_path__ + "static/media/new-created-page.f592ba11.png";